import { MAINTENANCE_CODE } from "@genbaryoku/contract";
import { useSyncExternalStore } from "react";

/**
 * メンテナンス中（#186、docs/75 e・docs/95）。API が 503 MAINTENANCE（管理アプリの案内の停止期間か、.env の MAINTENANCE_UNTIL があるあいだ）を返したら api.ts がここに知らせ、
 * App の MaintenanceGate が画面全体に止めの画面「メンテナンス中です」を重ねる（下の画面は外さない＝自動保存の書きかけは残り、
 * 「再読み込み」で送れていない直しがあればブラウザが確かめる）。戻すのは再読み込みだけ。
 * note＝案内の本文の1行目（何の保守か。docs/95 ★10）・overdue＝終了予定を過ぎて、まだ作業中（★4）
 */
type State = { on: false } | { on: true; endsAt: string | null; note: string | null; overdue: boolean };
let state: State = { on: false };
const listeners = new Set<() => void>();

export function reportMaintenance(problem: { status?: number; code?: unknown; endsAt?: unknown; note?: unknown; overdue?: unknown } | undefined, status: number): void {
  if (status !== 503 || !problem || problem.code !== MAINTENANCE_CODE) return;
  const endsAt = typeof problem.endsAt === "string" ? problem.endsAt : null;
  const note = typeof problem.note === "string" && problem.note.trim() ? problem.note : null;
  const overdue = problem.overdue === true;
  if (state.on && state.endsAt === endsAt && state.note === note && state.overdue === overdue) return;
  state = { on: true, endsAt, note, overdue };
  listeners.forEach((f) => f());
}

export function useMaintenance(): State {
  return useSyncExternalStore(
    (f) => {
      listeners.add(f);
      return () => listeners.delete(f);
    },
    () => state,
  );
}
